import React, { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import styles from "../Pages/PagesStyles/AdminPurchaseEntryNew.module.css";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import {
  OldGoldInvoiceEntryNewFields,
  PurchaseEntryNewFields,
} from "Components/support/Allfields/purchasefields";
import { Icon } from "@iconify/react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import GetApiService from "Components/Api/getapiService";
import Select from "react-select";
import { FaDollarSign } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import {
  DiamondFields,
  GeneralFields,
  generateDropDownList,
  resetValues,
  StoneFields,
} from "utils/helpers";
import SingleStonePopUp from "Components/support/purchasesupport/SingleStonePopUp";
import SingleDiamondPopUpNew from "./SingleDiamondPopUpNew";
import SingleStonePopUpNew from "./SignleStonePopUpNew";
import { Add } from "@mui/icons-material";
import { fetchAllRates } from "services/rate";
import { useSearchParams } from "react-router-dom";

const selectStyle = {
  control: (base) => ({
    ...base,
    minHeight: "35px",
    height: "30px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const InvoiceSkuForm = ({
  skus,
  isInvoiceEntry,
  itemfields,
  editValues,
  edit,
  updateSku,
  addSku,
  isSummaryOpen,
  setIsSummaryOpen,
  apifields,
  setItemfields,
  setCategory,
  oldGoldLocalfields,
  customerName,
  CustomerTounchList,
  gstCheckbox,
  rateList,
}) => {
  console.log(editValues);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);
  const fetchAllData = async () => {
    try {
      const [
        allSku,
        categories,
        productTypes,
        designs,
        purities,
        diamondAttributes,
        stoneAttributes,
      ] = await Promise.allSettled([
        apiService.fetchAllSku(),
        apiService.fetchAllCategories(),
        apiService.fetchAllProductType(),
        apiService.fetchAllDesigns(),
        apiService.fetchAllPurities(),
        apiService.fetchAllDiamondAttributes(),
        apiService.fetchAllStoneAttributesNew(),
      ]);

      // Check the results of each promise and handle errors if any
      const results = {
        allSku: allSku.status === "fulfilled" ? allSku.value : null,
        categories: categories.status === "fulfilled" ? categories.value : null,
        productTypes:
          productTypes.status === "fulfilled" ? productTypes.value : null,
        designs: designs.status === "fulfilled" ? designs.value : null,
        purities: purities.status === "fulfilled" ? purities.value : null,
        diamondAttributes:
          diamondAttributes.status === "fulfilled"
            ? diamondAttributes.value
            : null,
        stoneAttributes:
          stoneAttributes.status === "fulfilled" ? stoneAttributes.value : null,
      };

      // Log and handle any rejected promises (optional)
      const failedPromises = [
        allSku,
        categories,
        productTypes,
        designs,
        purities,
        diamondAttributes,
        stoneAttributes,
      ].filter((result) => result.status === "rejected");

      if (failedPromises.length > 0) {
        failedPromises.forEach((failedPromise) => {
          console.error(`Failed to fetch data: ${failedPromise.reason}`);
        });
      }

      return results;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw new Error(`Failed to fetch dropdown list data: ${error.message}`);
    }
  };
  const {
    data: dropdownListData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["editStockEntry/allData"],
    queryFn: fetchAllData,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
    onError: (err) => {
      console.error("Query Error:", err);
    },
  });

  const [fields, setFields] = useState([]);
  const [isToggled, setIsToggled] = useState(false);
  const [changeWastageWt, setChangeWastageWt] = useState(false);
  const [changeRate, setChangeRate] = useState(false);
  const [popup, setPopUp] = useState();
  const [isGrossWeightChanged, setIsGrossWeightChanged] = useState(false);
  const [isWastageFieldDisabled, setIsWastageFieldDisabled] = useState(false);
  // const searchParams = useSearchParams("")

  const fieldRefs = useRef([]);

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: edit
      ? editValues
      : {
          DiamondAmount: 0,
          Diamonds: [],
          Stones: [],
          Qty: 1,
          DiamondWeight: "10",
          ItemCode: "",
        },
  });

  const ItemCode = watch("ItemCode");
  const StockKeepingUnit = watch("StockKeepingUnit");
  const oldGoldPurchase = watch("OldGoldPurchase");
  const CategoryId = watch("CategoryId");
  const ProductId = watch("ProductId");
  const DesignId = watch("DesignId");
  const PurityId = watch("PurityId");
  const TotalWt = watch("TotalWt");
  const PackingWeight = watch("PackingWeight");
  const GrossWt = watch("GrossWt");
  const StoneWt = watch("StoneWt");
  const DiamondWeight = watch("DiamondWeight");
  const FinePercent = watch("FinePercent");
  const WastagePercent = watch("WastagePercent");
  const Hallmark = watch("Hallmark");
  const NetWt = watch("NetWt");
  const FineWt = watch("FineWt");
  const WastageWt = watch("WastageWt");
  const MetalRate = watch("GoldRate");
  const MakingPerGram = watch("MakingPerGram");
  const MakingFixedWastage = watch("MakingFixedWastage");
  const MakingFixedAmt = watch("MakingFixedAmt");
  const FineWastageWt = watch("FineWastageWt");
  const MetalAmount = watch("MetalAmount");
  const MakingPercent = watch("MakingPercent");
  const TotalMakingAmount = watch("TotalMakingAmount");
  const StoneAmount = watch("StoneAmount");
  const DiamondAmount = watch("DiamondAmount");
  const Stones = watch("Stones");
  const Diamonds = watch("Diamonds");
  const RateCut = watch("RateCut");
  const WastageCut = watch("WastageCut");
  const Qty = watch("Qty");
  const ClipQty = watch("ClipQty");
  const ClipWt = watch("ClipWt");
  const TagWt = watch("TagWt");
  const FindingWt = watch("FindingWt");
  const LanyardWt = watch("LanyardWt");
  const StonePieces = watch("StonePieces");
  const LooseDiamondWeight = watch("DiamondWeight");
  const LooseDiamondRate = watch("DiamondRate");
  const LooseStoneWeight = watch("StoneWeight");
  const LooseStonePieces = watch("StonePieces");
  const StoneRateCt = watch("StoneRateCt");
  const StoneRatePiece = watch("StoneRatePc");
  const GoldRate = watch("GoldRate");

  useEffect(() => {
    if (!edit && !StockKeepingUnit) {
      setValue("ProductId", "");
      setValue("DesignId", "");
      setValue("PurityId", "");
    }
  }, [CategoryId?.value, StockKeepingUnit, edit]);
  useEffect(() => {
    if (!edit && !StockKeepingUnit) {
      setValue("DesignId", "");
      setValue("PurityId", "");
    }
  }, [ProductId?.value, StockKeepingUnit, edit]);
  useEffect(() => {
    if (!edit && !StockKeepingUnit) {
      setValue("PurityId", "");
    }
  }, [DesignId?.value, StockKeepingUnit, edit]);

  useEffect(() => {
    setCategory(CategoryId?.value);
    if (CategoryId?.value) {
      const result = dropdownListData?.categories?.find(
        (item) => item?.Id == CategoryId?.value
      );
      setValue("HSNCode", result?.HSNCode);
    }
  }, [dropdownListData, CategoryId]);

  useEffect(() => {
    if (StockKeepingUnit?.value) {
      const sku = dropdownListData?.allSku?.find(
        (item) => item?.Id == StockKeepingUnit.value
      );
      console.log(sku);
      setValue("CategoryId", {
        value: sku?.CategoryId,
        label: sku?.CategoryName,
      });
      setValue("ProductId", { value: sku?.ProductId, label: sku?.ProductName });
      setValue("DesignId", { value: sku?.DesignId, label: sku?.DesignName });
      setValue("PurityId", { value: sku?.PurityId, label: sku?.PurityName });
      setValue("Pieces", sku?.Pieces);
      // setValue("StonePieces", +sku?.TotalStonePieces);
      // setValue("StoneAmount", +sku?.TotalStoneAmount);
      //   setValue("ClipWt", +sku?.ClipWeight);
      //   setValue("TagWt", +sku?.TagWeight);
    }
  }, [StockKeepingUnit]);

  useEffect(() => {
    if (!edit) {
      resetValues(setValue);
    }
  }, [oldGoldPurchase, edit]);

  useEffect(() => {
    if (
      rateList?.length &&
      rateList?.filter((item) => {
        if (
          item?.PurityId == PurityId?.value &&
          item?.CategoryId == CategoryId?.value
        ) {
          return item;
        }
      })?.length
    ) {
      let filteredItem = rateList?.filter(
        (item) =>
          item?.PurityId == PurityId?.value &&
          item?.CategoryId == CategoryId?.value
      );
      if (filteredItem?.length) {
        setValue("GoldRate", +(filteredItem[0]?.Rate || 0));
      }
    }
  }, [rateList, CategoryId?.value, PurityId?.value]);

  useEffect(() => {
    if (!oldGoldPurchase) {
      if (+(GoldRate || 0)) {
        setValue("RateCut", true);
      } else {
        setValue("RateCut", false);
      }
    }

    if (oldGoldPurchase) {
      setValue("Amount", (+(FineWt || 0) * +(GoldRate || 0))?.toFixed(2));
    }
  }, [GoldRate, FineWt]);

  useEffect(() => {
    const result = CustomerTounchList?.length
      ? CustomerTounchList?.filter((item) => {
          if (
            item?.CustomerId == customerName?.value &&
            item?.CategoryId == CategoryId?.value &&
            item?.ProductId == ProductId?.value &&
            item?.DesignId == DesignId?.value &&
            item?.PurityId == PurityId?.value
          ) {
            return item;
          }
        })
      : [];
    const customerTounch = CustomerTounchList?.length
      ? CustomerTounchList?.filter(
          (item) => item?.CustomerId == customerName?.value
        )
      : [];

    if (result?.length) {
      setValue("FinePercent", result[0]?.FinePercentage);
      setValue("MakingFixedAmt", result[0]?.MakingFixedAmt);
      setValue("MakingPercent", result[0]?.MakingPercentage);
      setValue("MakingPerGram", result[0]?.MakingPerGram);
      setValue("MakingFixedWastage", result[0]?.MakingFixedWastage);
      setIsWastageFieldDisabled(true);
    } else {
      if (!edit) {
        setIsWastageFieldDisabled(false);
        setValue("FinePercent", "");
        setValue("MakingFixedAmt", "");
        setValue("MakingPercent", "");
        setValue("MakingPerGram", "");
        setValue("MakingFixedWastage", "");
      }
    }

    let StoneAmount = 0;
    if (
      Stones?.length &&
      customerTounch?.length &&
      customerTounch[0]?.Stones?.length
    ) {
      Stones.forEach((stoneItem) => {
        customerTounch[0]?.Stones?.forEach((tounchStone) => {
          if (tounchStone?.StoneName == stoneItem?.StoneName) {
            StoneAmount +=
              +(stoneItem?.StoneWeight || 0) * +(tounchStone?.StoneRate || 0);
          }
        });
      });

      setValue("StoneAmount", +(StoneAmount || 0)?.toFixed(2));
    }
  }, [
    CustomerTounchList,
    customerName?.value,
    CategoryId?.value,
    ProductId?.value,
    DesignId?.value,
    PurityId?.value,
    Stones,
  ]);

  // --------------calculations starts here --------------
  useEffect(() => {
    // if (CategoryId?.label !== "LOOSE DIAMOND") {
    const grossWeight = +(TotalWt || 0) - +(PackingWeight || 0);
    const netWeight =
      +(grossWeight || 0) - +(StoneWt || 0) - +(DiamondWeight || 0);
    const fineWeight = (+(FinePercent || 0) * +(netWeight || 0)) / 100;
    const wastageWeight =
      // +changeWastageWt
      // ?
      //  (+WastagePercent * +fineWeight) / 100
      // :
      (+(MakingPercent || 0) * +(netWeight || 0)) / 100;

    const fineWastageWeight =
      +(fineWeight || 0) + +(wastageWeight || 0) + +(MakingFixedWastage || 0);

    // const makingPerGram = +netWeight * +MetalRate;
    const totalMakingAmount =
      (+(MakingPercent || 0) / 100) * +(netWeight || 0) * +(MetalRate || 0) +
      +(MakingPerGram || 0) * netWeight +
      +(MetalRate || 0) * +(MakingFixedWastage || 0) +
      +MakingFixedAmt;

    const metalAmount = +(MetalRate || 0) * +(netWeight || 0);
    const totalItemAmount =
      +(metalAmount || 0) +
      +(totalMakingAmount || 0) +
      +(StoneAmount || 0) +
      +(Hallmark || 0) +
      +(DiamondAmount || 0); // need to add diamond amount
    console.log(totalItemAmount);
    // Update all values
    setValue("GrossWt", grossWeight || 0);
    setValue("NetWt", (netWeight || 0)?.toFixed(3));
    setValue("FineWt", (fineWeight || 0)?.toFixed(3));
    // setValue("WastageWt", wastageWeight?.toFixed(3));
    setValue("FineWastageWt", (fineWastageWeight || 0)?.toFixed(3));
    //   if(Qty){
    //     setValue("ClipQty", Qty);
    //   }
    //   if(PackingWeight){
    //     setValue("ClipQty", "");
    //     setValue("ClipWt", "");
    //     setValue("TagWt", "");
    //     setValue("FindingWt", "");
    //     setValue("LanyardWt", "");
    //   }
    // setValue("MakingPerGram", makingPerGram);

    if (RateCut) {
      setValue("TotalMakingAmount", totalMakingAmount?.toFixed(3));
      setValue("TotalItemAmount", totalItemAmount?.toFixed(3));
      setValue("MetalAmount", metalAmount?.toFixed(3));
      setValue("FineWt", "");
      setValue("WastageWt", "");
      setValue("FineWastageWt", "");
    } else {
      setValue(
        "TotalMakingAmount",
        (
          +(MakingPerGram || 0) * +(netWeight || 0) +
          +(MakingFixedAmt || 0)
        )?.toFixed(3)
      );
      setValue(
        "TotalItemAmount",
        (
          +(MakingPerGram || 0) * +(netWeight || 0) +
          +(MakingFixedAmt || 0) +
          +(Hallmark || 0) +
          +(StoneAmount || 0) +
          +(DiamondAmount || 0)
        ).toFixed(3)
      );
      setValue("FineWt", (fineWeight || 0)?.toFixed(3));
      setValue(
        "WastageWt",
        (+(wastageWeight || 0) + +(MakingFixedWastage || 0))?.toFixed(3)
      );
      setValue("FineWastageWt", (fineWastageWeight || 0)?.toFixed(3));
    }

    // + +StoneAmount + +Diamo?ndAmount).toFixed(3))
    // }
  }, [
    TotalWt,
    PackingWeight,
    StoneWt,
    DiamondWeight,
    FinePercent,
    MakingPercent,
    MetalRate,
    WastageWt,
    MakingFixedWastage,
    MakingFixedAmt,
    StoneAmount,
    MakingPerGram,
    Hallmark,
    DiamondAmount,
    Qty,
    FineWt,
    RateCut,
  ]);

  // useEffect(()=>{
  //   if(TotalWt && PackingWeight && isGrossWeightChanged){
  //     setValue("PackingWeight",+TotalWt - +GrossWt)
  //     setValue("GrossWt",+TotalWt - +PackingWeight)
  //   }
  // },[isGrossWeightChanged])

  // --------------calculations ends here --------------

  const handleAddSku = () => {
    handleSubmit(onSubmit)();
  };
  const onSubmit = (data) => {
    console.log(data);
    if (edit) {
      updateSku(data);
    } else {
      addSku(data, false);
    }
  };

  return (
    <>
      {popup?.status && popup?.label == "Stone" ? (
        <SingleStonePopUpNew
          onClose={() => setPopUp({ status: false, label: "" })}
          dropdownListData={dropdownListData}
          addStone={(data) => {
            setValue("Stones", data?.stones);
            setPopUp({ status: false, label: "" });
          }}
          Stones={Stones}
          StonePieces={StonePieces}
          setFormValue={setValue}
          ItemCode={ItemCode}
          CustomerTounchList={CustomerTounchList}
          customerName={customerName}
          clientCode={clientCode}
        />
      ) : (
        ""
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "0px 20px",
        }}
      >
        <label>URD Purchase</label>
        <div className={styles.switch}>
          {/* <input
                  type="checkbox"
                  id="toggleSwitch"
                  className={styles.switchinput}
                  checked={isToggled}
                  onChange={() => setIsToggled(!isToggled)}
                /> */}
          <input
            disabled={
              // edit
              false
            }
            type="checkbox"
            id="toggleSwitch"
            className={styles.switchinput}
          
            {...register("OldGoldPurchase")}
          />
          <label className={styles.switchlabel} htmlFor="toggleSwitch"></label>
        </div>
      </div>

      <div className={styles.linesection}>
        <div className={styles.middlecontainer}>
          {(oldGoldPurchase ? oldGoldLocalfields : itemfields)
            ?.filter((field) => field?.place === "middle" && field.IsVisible)
            ?.sort((a, b) => a.priority - b.priority)
            ?.map((field, index) => (
              <div className={styles.box} key={field.key}>
                <label title={field.label}>
                  {field.label.substring(0, 14)}{" "}
                  {field.label?.length > 14 && "..."}
                  {(field?.mandatory ||
                    (field?.key == "GoldRate" && gstCheckbox)) && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </label>
                {field.type === "inputselect" ? (
                  // SKU Input with datalist
                  <input
                    type="text"
                    name={field.key}
                    disabled={field.visibility === "ReadOnly"}
                    {...register(field.key, {
                      required:
                        field?.mandatory &&
                        field.visibility !== "ReadOnly" &&
                        `${field.label} is required`,
                    })}
                    list="skuList"
                    autoComplete="off"
                    style={{ background: "white", border: "1px solid #ddd" }}
                    // ref={(el) => (inputRefs.current[index] = el)}
                    // onKeyDown={(e) => handleKeyDown(e, index)}
                    onKeyDown={(e) => {
                      if (e?.code == "Enter") {
                        e.preventDefault(); // Prevent form submission
                      }
                    }}
                  />
                ) : field.type === "dropdown" ||
                  field.type === "searchDropdown" ? (
                  <>
                  {console.log("--------",generateDropDownList({
                            field,
                            dropdownListData,
                            CategoryId,
                            ProductId,
                            DesignId,
                            PurityId,
                            skus,
                            customerName,
                            oldGoldPurchase
                          }))}
                    <Controller
                      name={field.key}
                      control={control}
                      rules={{
                        required:
                          field?.mandatory &&
                          field.visibility !== "ReadOnly" &&
                          `${field.label} is required`,
                        validate: (value) => {
                          if (
                            field?.mandatory &&
                            field.visibility !== "ReadOnly" &&
                            value?.value === ""
                          ) {
                            return `${field.label} cannot be empty`;
                          }
                        },
                      }}
                      
                      render={({ field: controllerField }) => (
                        <Select
                          {...controllerField}
                          options={generateDropDownList({
                            field,
                            dropdownListData,
                            CategoryId,
                            ProductId,
                            DesignId,
                            PurityId,
                            skus,
                            customerName,
                            oldGoldPurchase
                          })?.map((item) => ({
                            value: item?.value,
                            label: item?.label,
                          }))}
                          isDisabled={
                            field.visibility === "ReadOnly" ||
                            ((field.key == "CategoryId" ||
                              field.key == "ProductId" ||
                              field.key == "DesignId" ||
                              field.key == "PurityId") &&
                              StockKeepingUnit?.value)
                          }
                          isSearchable={field.type === "searchDropdown"}
                          styles={selectStyle}
                          // ref={(el) => (inputRefs.current[index] = el)}
                          // onKeyDown={(e) => handleKeyDown(e, index)}
                        />
                      )}
                    />
                  </>
                ) : field.type === "number" || field.type === "text" ? (
                  // Number input field
                  <div style={{ position: "relative" }}>
                    {field.key == "WastagePercent" && (
                      <FiRefreshCcw
                        onClick={() => {
                          if (WastageCut) {
                            setValue("WastageCut", false);
                          } else {
                            setValue("WastageCut", true);
                          }
                        }}
                        style={{
                          color: `${WastageCut ? "#0077d4" : "#627282"}`,
                          cursor: "pointer",
                          position: "absolute",
                          right: "4px",
                          top: "6px",
                        }}
                        size={20}
                      />
                    )}

                    {field.key == "MetalRate" && (
                      <FaDollarSign
                        onClick={() => {
                          if (RateCut) {
                            setValue("RateCut", false);
                          } else {
                            setValue("RateCut", true);
                          }
                        }}
                        style={{
                          color: `${RateCut ? "#0077d4" : "#627282"} `,
                          cursor: "pointer",
                          position: "absolute",
                          right: "4px",
                          top: "6px",
                        }}
                        size={20}
                      />
                    )}

                    <input
                      type={field.type}
                      name={field.key}
                      step="0.001"
                      disabled={
                        field.visibility === "ReadOnly" ||
                        (field.key == "ClipQty" && Qty) ||
                        ((+PackingWeight || +TotalWt) &&
                          field.key == "GrossWt") ||
                        (PackingWeight &&
                          (field.key == "ClipQty" ||
                            field.key == "ClipWt" ||
                            field.key == "TagWt" ||
                            field.key == "FindingWt" ||
                            field.key == "LanyardWt")) ||
                        (field.key == "MakingPercent" &&
                          isWastageFieldDisabled) ||
                        (+StoneRateCt && field.key == "StoneRatePc") ||
                        (+StoneRatePiece && field.key == "StoneRateCt")
                      }
                      {...register(field.key, {
                        required:
                          (field?.mandatory &&
                            field.visibility !== "ReadOnly") ||
                          (field?.key == "GoldRate" &&
                            gstCheckbox &&
                            `${field.label} is required`),
                        pattern:
                          field.type === "number"
                            ? /^\d+(\.\d{0,3})?$/
                            : undefined, // Validate input
                        validate: (value) => {
                          if (
                            field.key == "PackingWeight" &&
                            +PackingWeight > +TotalWt
                          ) {
                            return "Packing weight cannot exceed total weight.";
                          }
                          if (field.key == "GrossWt" && GrossWt > TotalWt) {
                            return "Gross weight cannot exceed total weight.";
                          }
                        },
                      })}
                      // ref={(el) => (inputRefs.current[index] = el)} // Store ref
                      // onKeyDown={(e) => handleKeyDown(e, index)} // Handle Enter key
                      style={{
                        background: `${
                          field.visibility == "ReadOnly" ||
                          (field.key == "ClipQty" && Qty) ||
                          field.key == "GrossWt" ||
                          (+StoneRateCt && field.key == "StoneRatePc") ||
                          (+StoneRatePiece && field.key == "StoneRateCt") ||
                          (PackingWeight &&
                            (field.key == "ClipQty" ||
                              field.key == "ClipWt" ||
                              field.key == "TagWt" ||
                              field.key == "FindingWt" ||
                              field.key == "LanyardWt"))
                            ? "#f0f0f0"
                            : "white"
                        }`,
                        border: "1px solid #ddd",
                        height: "35px",
                      }}
                    />
                  </div>
                ) : field.type === "popup" ? (
                  <div>
                    <div
                      className="input-group"
                      style={{ position: "relative", height: "35px" }}
                    >
                      <input
                        id="stone-input"
                        type="text"
                        style={{ margin: 0 }}
                        className="input-field"
                        onKeyDown={(e) => {
                          if (e?.code == "Enter") {
                            e.preventDefault(); // Prevent form submission
                            setPopUp({ status: true, label: field.key });
                          }
                        }}
                      />
                      <Add
                        type="button"
                        size={28}
                        onClick={() => {
                          setPopUp({ status: true, label: field.key });
                        }}
                        style={{
                          background: "#A9A9A9",
                          cursor: "pointer",
                          height: "100%",
                          color: "white",
                        }}
                      />

                      {/* <button
                        className="add-button"
                        type="button"
                        onClick={() => {
                          setPopUp({ status: true, label: field.key });
                        }}
                      >
                        +
                      </button> */}
                    </div>
                  </div>
                ) : null}
                {errors[field.key] && (
                  <span className={styles.fielderror}>
                    {errors[field.key].message}
                  </span>
                )}
              </div>
            ))}
        </div>

        <div className={styles.custombarlinehead}>
          <div></div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              type="button"
              style={{
                padding: "4px 8px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                fontSize: "14px",
                backgroundColor: "#0077d4",
              }}
              onClick={handleAddSku}
            >
              <Icon style={{ fontSize: "24px" }} icon="fluent:add-32-filled" />
              Add
            </button>
            <button
              type="button"
              style={{
                fontSize: "14px",
                backgroundColor: "#0077d4",
                padding: "4px 8px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => setIsSummaryOpen(!isSummaryOpen)}
            >
              <Icon style={{ fontSize: "24px" }} icon="solar:list-bold" />
              Summary
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceSkuForm;
